// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slick-list,
.slick-slider,
.slick-track {
  position: relative;
  display: block;
}
.slick-loading .slick-slide,
.slick-loading .slick-track {
  visibility: hidden;
}
.slick-slider {
  box-sizing: border-box;
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -khtml-user-select: none;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
}
.slick-list {
  overflow: hidden;
  margin: 0;
  padding: 0;
}
.slick-list:focus {
  outline: 0;
}
.slick-list.dragging {
  cursor: pointer;
  cursor: hand;
}
.slick-slider .slick-list,
.slick-slider .slick-track {
  transform: translate3d(0, 0, 0);
}
.slick-track {
  top: 0;
  left: 0;
}
.slick-track:after,
.slick-track:before {
  display: table;
  content: '';
}
.slick-track:after {
  clear: both;
}
.slick-slide {
  display: none;
  float: left;
  height: 100%;
  min-height: 1px;
}
[dir='rtl'] .slick-slide {
  float: right;
}
.slick-slide img {
  display: block;
}
.slick-slide.slick-loading img {
  display: none;
}
.slick-slide.dragging img {
  pointer-events: none;
}
.slick-initialized .slick-slide {
  display: block;
}
.slick-vertical .slick-slide {
  display: block;
  height: auto;
  border: 1px solid transparent;
}
.slick-arrow.slick-hidden {
  display: none;
}
.slick-prev,
.slick-next {
  position: absolute;
  top: auto;
  bottom: 10%;
  z-index: 10;
  color: black;
}
.slick-prev {
  left: 10%;
}
.slick-next {
  right: 10%;
}
.slick-dots {
  position: absolute;
  bottom: 10%;
}
/* the slides in order to add space between slides we need padding*/
.slick-slide {
  padding: 0 10px;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/login/carousel/slick.min.css"],"names":[],"mappings":"AAAA;;;EAGE,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EAGzB,iBAAiB;EACjB,2BAA2B;EAC3B,wBAAwB;EAExB,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;;EAME,+BAA+B;AACjC;AACA;EACE,MAAM;EACN,OAAO;AACT;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA,mEAAmE;AACnE;EACE,eAAe;AACjB","sourcesContent":[".slick-list,\n.slick-slider,\n.slick-track {\n  position: relative;\n  display: block;\n}\n.slick-loading .slick-slide,\n.slick-loading .slick-track {\n  visibility: hidden;\n}\n.slick-slider {\n  box-sizing: border-box;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -khtml-user-select: none;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  -webkit-tap-highlight-color: transparent;\n}\n.slick-list {\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n}\n.slick-list:focus {\n  outline: 0;\n}\n.slick-list.dragging {\n  cursor: pointer;\n  cursor: hand;\n}\n.slick-slider .slick-list,\n.slick-slider .slick-track {\n  -webkit-transform: translate3d(0, 0, 0);\n  -moz-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n  -o-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n.slick-track {\n  top: 0;\n  left: 0;\n}\n.slick-track:after,\n.slick-track:before {\n  display: table;\n  content: '';\n}\n.slick-track:after {\n  clear: both;\n}\n.slick-slide {\n  display: none;\n  float: left;\n  height: 100%;\n  min-height: 1px;\n}\n[dir='rtl'] .slick-slide {\n  float: right;\n}\n.slick-slide img {\n  display: block;\n}\n.slick-slide.slick-loading img {\n  display: none;\n}\n.slick-slide.dragging img {\n  pointer-events: none;\n}\n.slick-initialized .slick-slide {\n  display: block;\n}\n.slick-vertical .slick-slide {\n  display: block;\n  height: auto;\n  border: 1px solid transparent;\n}\n.slick-arrow.slick-hidden {\n  display: none;\n}\n.slick-prev,\n.slick-next {\n  position: absolute;\n  top: auto;\n  bottom: 10%;\n  z-index: 10;\n  color: black;\n}\n.slick-prev {\n  left: 10%;\n}\n.slick-next {\n  right: 10%;\n}\n.slick-dots {\n  position: absolute;\n  bottom: 10%;\n}\n/* the slides in order to add space between slides we need padding*/\n.slick-slide {\n  padding: 0 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
